import type { KnowledgeItem } from '@/types';

export const fccKnowledge: KnowledgeItem[] = [
  {
    id: 'k1',
    question: '催化裂化装置的主要设备有哪些？',
    answer: '主要设备包括：反应器（进行裂化反应）、再生器（烧焦再生催化剂）、分馏塔（分离反应产物）、吸收稳定系统（分离液化气）、主风机（提供烧焦用空气）、气压机（压缩富气）。',
    tags: ['设备', '概述'],
  },
  {
    id: 'k2',
    question: '反应温度对产品质量有什么影响？',
    answer: '反应温度升高，汽油辛烷值提高，但气体产率增加；温度降低，柴油产率增加。一般控制在480-520°C，根据产品方案调整。',
    tags: ['反应器', '温度', '产品质量'],
  },
  {
    id: 'k3',
    question: '催化剂循环量不足会有什么后果？',
    answer: '催化剂循环量不足会导致：1) 反应深度下降，转化率降低；2) 生焦减少，再生器温度下降；3) 产品分布变差，汽油收率降低。应及时检查塞阀或滑阀开度。',
    tags: ['催化剂', '故障'],
  },
  {
    id: 'k4',
    question: '分馏塔底油浆固含量高的原因？',
    answer: '主要原因：1) 催化剂破碎严重；2) 油浆回流比过大；3) 分馏塔底温度过低；4) 催化剂跑损。应检查催化剂物理性质和分馏塔操作参数。',
    tags: ['分馏塔', '故障', '油浆'],
  },
  {
    id: 'k5',
    question: '主风机突然停机怎么处理？',
    answer: '紧急处理步骤：1) 立即切断反应器进料；2) 打开主风事故蒸汽；3) 维持催化剂流化；4) 关闭再生器塞阀；5) 通知调度。这是Ⅰ级事故，需按紧急预案执行。',
    tags: ['主风机', '紧急事故', '操作步骤'],
  },
];
